import { useEffect, useRef } from 'react';

// TODO use camponents
export const formatDate = (date, format = 'YYYY-MM-DD', invalidString = '') => {
  // const newDate = dayjs(date).format(format);
  //
  // if (newDate === 'Invalid date') {
  //   return invalidString;
  // }
  //
  // return newDate;
};

// TODO use camponents
export const getDateFromString = (dateString, defaultToNow = true) => {
  if (!dateString && defaultToNow) {
    return new Date();
  }

  return new Date(dateString);
};

// TODO use camponents
export function filterUnique(list) {
  if (!list) {
    return [];
  }

  return list.filter((value, index, self) => self.indexOf(value) === index);
}

// TODO use camponents
export const getLabelForValue = (value, items) =>
  items?.find((item) => item?.value === value)?.label;

// TODO use camponents
export const itemsAsValueList = (items, valueProperty = 'id', labelProperty = 'name') => {
  if (!items || items?.length === 0) {
    return [];
  }

  return items?.map((item) => ({
    value: item?.[valueProperty],
    label: item?.[labelProperty],
  }));
};

// TODO use camponents
export const isVoid = (item) => item === null || item === undefined;

export const sortValues = (a, b, descending = false) => {
  if (a === b) {
    return 0;
  }

  if (!isVoid(a) && isVoid(b)) {
    // console.log("found a null, a is bigger", a);
    return descending ? -1 : 1;
  }

  if (isVoid(a) && !isVoid(b)) {
    // console.log("found a null, b is bigger", b);
    return descending ? 1 : -1;
  }

  return a > b ? (descending ? -1 : 1) : descending ? 1 : -1;
};

// TODO this is duplicated in helpers/helpers. Should delete one
export const sortObjectList = (items, property = 'name', descending = false) =>
  items?.sort((a, b) => sortValues(a?.[property], b?.[property], descending));

// Plucks out specific keys from an object and returns only them in a new object
// TODO use camponents
export const pluck = (object, keys) => {
  const newObject = {};

  if (!keys || keys?.length === 0) {
    return [];
  }

  keys?.forEach((key) => {
    if (Object.hasOwn(object, key)) {
      newObject[key] = object[key];
    }
  });

  return newObject;
};

/**
 * Flatten an array of objects into just the values of a specific key
 * // TODO use camponents
 */
export const flatten = (array, key = 'id') => {
  if (!array?.length) {
    return [];
  }

  return array?.map((item) => item?.[key]);
};

// TODO use camponents
export const filterByProperty = (array, value, property = 'user_id') => {
  if (!array || array?.length === 0 || value === undefined) {
    return [];
  }

  return array?.filter((item) => item?.[property] === value);
};

// TODO use camponents
export const mergeArrays = (oldArray, newArray, property) => {
  // Loop through old array, keeping any objects that aren't overridden
  const oldItemsToKeep = oldArray.filter(
    (oldItem) =>
      newArray.find((newItem) => newItem?.[property] === oldItem?.[property]) === undefined,
  );

  return [...newArray, ...oldItemsToKeep];
};

/**
 * Searches a list of objects and returns the first entry where the key matches
 * the given value
 * // TODO use camponents
 */
export const findByKey = (array, value, key = 'id') => {
  if (!array || array?.length === 0 || value === undefined) {
    return null;
  }

  return array?.find((item) => item?.[key] === value);
};

// TODO use camponents
export const pluralise = (string, number, pluralString) => {
  if (number === 1) {
    return string;
  }

  if (pluralString) {
    return pluralString;
  }

  return `${string}s`;
};

// TODO use camponents
export const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

// Reduce an array of objects down to the list of values of that property.
// E.g. a list of strings representing an id or name
// TODO use camponents
export const flattenToProperty = (array, property = 'id') => {
  if (!array || array?.length === 0) {
    return null;
  }

  return array?.map((item) => item?.[property]);
};

/**
 * Convert a string into one that's good for searching.
 * Set to lower case, remove extra whitespace, etc.
 * // TODO use camponents
 */
export const getStringForSearch = (string) => string?.toLowerCase()?.trim().replace(/\s/g, '');

/**
 * Get whether the search string appears in the search text
 * TODO allow a list of search texts
 * // TODO use camponents
 * @param stringToSearch
 * @param searchText
 * @returns {*}
 */
export const stringInString = (stringToSearch, searchText) =>
  getStringForSearch(stringToSearch)?.includes(getStringForSearch(searchText));

// TODO use camponents
export const createRandomString = (length) => Math.random().toString(36).substr(2, length);

/**
 * Move an item from one index to another.
 * Inserts BEFORE the destination. e.g. 0 will put at the start of the list
 * // TODO use camponents
 */
export const move = (array, from, to) => {
  if (from === to) {
    return array;
  }

  const alteredArray = [...array];
  const itemToMove = alteredArray.splice(from, 1)[0];

  // console.log("MOVING", [...array], from, to);
  // console.log("item to move", itemToMove);
  // console.log("array without item", alteredArray);

  // Move to end if -1
  if (to === -1) {
    return [...alteredArray, itemToMove];
  }

  if (from < to) {
    // index of to has shifted down one
    alteredArray.splice(to - 1, 0, itemToMove);
  } else {
    alteredArray.splice(to, 0, itemToMove);
  }

  return alteredArray;
};

/**
 * Groups the list of objects by the value of the given property.
 *
 * e.g. [{id: 1, category: 'foo'}, {id: 2, category: 'bar'}] => {foo: [{id: 1, category: 'foo'}], bar: [{id: 2, category: 'bar'}]}
 */
export const groupByProperty = (items, property = 'id') => {
  const newObject = {};

  if (!items || items?.length === 0) {
    return {};
  }

  items?.forEach((item) => {
    if (isVoid(newObject[item?.[property]])) {
      newObject[item?.[property]] = [];
    }

    newObject[item?.[property]].push(item);
  });

  return newObject;
};

export const range = (size, startAt = 0) => {
  return [...Array(size).keys()].map((i) => i + startAt);
};
